import NameLinkCell from '@/components/NameLinkCell';
import React, { type FC, memo } from 'react';

import styles from '../styles.module.css';

type StudyNameCellProps = { data: { id: string; name: string } };

const StudyNameCell: FC<StudyNameCellProps> = ({ data: { id, name } }) => (
  <NameLinkCell
    className={styles.studyName}
    id={id}
    name={name}
    params={{ studyId: String(id) }}
    testId="study-name-btn"
    to="/studies/$studyId"
  />
);

export default memo(StudyNameCell);
